import { type FC } from 'react'

import { Box, Button, Table, Tag, Text, useToggle } from '@factorialco/deprecated-design-system'
import { RoleCompetencyFragment } from 'generated/resources/graphql'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import ConfirmationModal from 'modules/job_catalog/components/ConfirmationModal'

interface Props {
  competency: RoleCompetencyFragment
  onUnassign: () => void
  canEditJob: boolean
}

const Row: FC<Props> = ({ competency, onUnassign, canEditJob }) => {
  const { navigation } = useNavigation()
  const [isOpen, toggleOpen] = useToggle()
  const editCompetencyPath = navigation.competencies.competencyId.settings.fullPath({
    competencyId: competency.id,
  })

  const handleUnassign = () => {
    toggleOpen(true)()
  }

  return (
    <Table.Row background="grey000White">
      <Table.Cell colSpan={3}>
        <Text.Normal color="grey1000" weight="medium">
          {competency.name}
        </Text.Normal>
      </Table.Cell>
      <Table.Cell colSpan={6}>
        <Text.Normal color="grey1000">{competency.description}</Text.Normal>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Box inline>
          <Tag
            icon={competency?.everyone ? 'office' : 'briefcase'}
            leftItem="icon"
            size="normal"
            type="transparent"
          >
            {competency?.everyone
              ? i18n.t('job_catalog.competencies.everyone')
              : i18n.t('job_catalog.competencies.specific_role')}
          </Tag>
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={1}>
        {canEditJob && (
          <Box alignItems="flexEnd">
            <PopoverMenu type="list">
              <PopoverMenu.Trigger>
                <Button.Decorative type="secondary" iconName="ellipsis" />
              </PopoverMenu.Trigger>
              <PopoverMenu.Content side="bottom" align="center">
                <PopoverMenu.RouterOption
                  title={i18n.t('job_catalog.competencies.edit_competency')}
                  to={{ pathname: editCompetencyPath }}
                />
                {!competency.everyone && (
                  <PopoverMenu.TouchableOption
                    title={i18n.t('job_catalog.competencies.unassign_from_role')}
                    onClick={handleUnassign}
                    danger
                  />
                )}
              </PopoverMenu.Content>
            </PopoverMenu>
          </Box>
        )}
      </Table.Cell>
      {isOpen && (
        <ConfirmationModal
          title={i18n.t('job_catalog.competencies.unassign_competency_title')}
          description={i18n.t('job_catalog.competencies.unassign_competency_description')}
          onCancel={toggleOpen(false)}
          onConfirm={onUnassign}
        />
      )}
    </Table.Row>
  )
}

export default Row
